import { gql } from '@apollo/client';

export const GET_OFFLINE_STORES = gql(/* GraphQL */ `
    query GetOfflineStores($date: DateTime!) {
        getOfflineStores(date: $date) {
            id
            storeNo
            name
            division
            opsArea
            countryCode
            posSystem
        }
    }
`);

export default GET_OFFLINE_STORES;
